import React, { HTMLAttributes } from "react";
import "./grid-table.css";

export interface GridTableUIProps {
  /** Bordered table (default: true) */
  uiBorder?: boolean;
}

export type GridTableProps = HTMLAttributes<HTMLDivElement> & GridTableUIProps;

/** Table wrapper (flex column) */
export default function GridTable({
  className,
  uiBorder = true,
  children,
  ...rest
}: GridTableProps) {
  const classes = [
    "grid-table",
    uiBorder && "grid-table--bordered",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
